import { createBrowserRouter } from 'react-router-dom';
import App from '../App';
import Login from '../pages/auth/Login';
import Error404Page from '@/pages/error/Error404Page';
import Unauthorized from '@/pages/error/Unauthorized';
import Routes from './routes';
import SuperAdminDashboard from '@/pages/super-admin/SuperAdminDashboard';
import SuperAdminWrapper from '@/layouts/SuperAdminWrapper';
import SuperAdminOrganizations from '@/pages/super-admin/Organizations/SuperAdminOrganizations';
import SuperAdminUsers from '@/pages/super-admin/Users/SuperAdminUsers';
import SuperAdminTellets from '@/pages/super-admin/Tellets/SuperAdminTellets';
import SuperAdminPrompts from '@/pages/super-admin/Prompts/SuperAdminPrompts';
import SuperAdminSingleOrganization from '@/pages/super-admin/Organizations/SuperAdminSingleOrganization';

const RouterWrapper = () => {
  const router = createBrowserRouter([
    // -- PUBLIC ROUTES --

    {
      index: true,
      path: Routes.home.path,
      element: <App />,
    },
    {
      path: Routes.login.path,
      element: <Login />,
    },
    {
      path: Routes.unauthorized.path,
      element: <Unauthorized />,
    },
    // -- SUPER ADMIN ROUTES START --

    {
      element: <SuperAdminWrapper />,
      children: [
        {
          path: Routes.super_admin_dashboard.path,
          element: <SuperAdminDashboard />,
        },
        {
          path: Routes.super_admin_dashboard_organizations.path,
          element: <SuperAdminOrganizations />,
        },
        {
          path: `${Routes.super_admin_dashboard_single_organization.path}/:org_id`,
          element: <SuperAdminSingleOrganization />,
        },
        {
          path: Routes.super_admin_dashboard_users.path,
          element: <SuperAdminUsers />,
        },
        {
          path: Routes.super_admin_dashboard_tellets.path,
          element: <SuperAdminTellets />,
        },
        {
          path: Routes.super_admin_dashboard_prompts.path,
          element: <SuperAdminPrompts />,
        },
      ],
    },

    // -- CATCH ALL ERRORS --
    {
      path: 'error_404',
      element: <Error404Page />,
    },
    {
      path: '*',
      element: <Unauthorized />,
    },
  ]);

  return router;
};

export default RouterWrapper;
